<script>
import RawData from "@/components/widgets/raw-data.vue";
import InventoryCardList from "./inventory-card-list.vue";
export default {
    name: "NotFoundItems",
    props: {
        itemData: {
            type: Object,
            required: true,
        },
    },
    components: {
        RawData,
        InventoryCardList,
    },
    computed: {
        propertyFiltered() {
            if (this.itemData) {
                let data = this.itemData.notFoundItems;
                if(this.filterEmployeeId) {
                    data = data.filter((item) => {
                        return item.employeeIdNumber == this.filterEmployeeId;
                    });
                }
                if (this.itemData.filter.trim() != "" && this.itemData.filter) {
                    data = data.filter((item) => {
                        return item.filterKey.toUpperCase().includes(this.itemData.filter.toUpperCase());
                    });
                }
                return data;
            }
            return [];
        },
        propertyRows() {
            if (this.itemData) {
                if ((this.itemData.filter.trim() != "" && this.itemData.filter) || this.filterEmployeeId) {
                    return this.propertyFiltered.length;
                } else {
                    return this.itemData.notFoundItems.length;
                }
            }
            return 0;
        },
    },
    data() {
        return {
            propertyFields: [
                {
                    key: "Name",
                    sortable: true,
                    label: "Property",
                },
            ],
            sortBy: "id",
            sortDesc: true,
            currentPage: 1,
            perPage: 10,
        };
    },
    methods: {
        resetToggle(row) {
            row.toggleAll = false;
            row.notFoundItems.map((item) => {
                item.items.map((prop) => {
                    prop.toggleSelected = false;
                });
            });
        },
    }
};
</script>
<template>
    <div class="mt-2">
        <!-- <div class="d-flex justify-content-between mb-2">
            <div class="d-flex">

            </div>
            <div class="d-flex mt-1">
                <div class="d-flex align-items-center float-end">
                    <button
                        type="button"
                        @click="$emit('selectFundCluster', 'rpcsp')"
                        class="btn btn-sm btn-purple d-flex align-items-center ms-1"
                    >
                        <i class="bx bx-printer fs-6 me-1"></i>Print RPCSP
                    </button>
                    <button
                        type="button"
                        @click="$emit('selectFundCluster', 'rpcppe')"
                        class="btn btn-sm btn-purple d-flex align-items-center ms-1"
                    >
                        <i class="bx bx-printer fs-6 me-1"></i>Print RPCPPE
                    </button>
                </div>
            </div>
        </div> -->
        <b-table
            class="propertyTable datatables target-table"
            :items="propertyFiltered"
            :fields="propertyFields"
            responsive="sm"
            :per-page="itemData.perPage"
            :current-page="itemData.currentPage"
            :sort-by="sortBy"
            :sort-desc="false"
            :busy="itemData.tableBusy"
            bordered
            show-empty
        >
            <template #empty>
                <b-card-header>
                    <div class="text-center">
                        <div v-if="itemData.filter != ''">
                            <i class="fas fa-exclamation-triangle me-2"></i>There
                            are no properties matching your request
                        </div>
                    <div v-else>
                        <i class="fas fa-exclamation-triangle me-2"></i>No
                        properties available
                    </div>
                    </div>
                </b-card-header>
            </template>
            <template #table-busy>
                <b-card-header>
                    <div class="d-flex justify-content-center align-items-center p-2">
                        <div class="preloader-component me-2">
                            <div class="status">
                                <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                </div>
                            </div>
                        </div>
                        <strong>Loading...</strong>
                    </div>
                </b-card-header>
            </template>
            <template #cell(name)="accountableRow">
                <div class="position-relative ms-1">
                    <RawData 
                        :data="accountableRow.item" 
                        v-if="$store.state.decrypt.isAdmin()" 
                        :keyId="accountableRow.item.employeeIdNumber"
                        :exclude="['properties']"
                    />
                </div>
                <div class="py-2">
                    <div 
                        class="d-flex justify-content-between cursor-pointer px-3 pb-1" 
                        @click="accountableRow.item.showProperty = !accountableRow.item.showProperty"
                        :class="{'mb-2 border-bottom': accountableRow.item.showProperty}"
                    >
                        <div>
                            <span class="text-warning font-size-17">{{ accountableRow.item.accountableOfficer }}</span>
                            <div class="d-flex gap-1">
                                <button class="btn btn-purple btn-sm" @click.stop="$emit('printDemandLetter', accountableRow.item)"><i class="bx bx-printer"></i> Print Demand Letter</button>
                                <button class="btn btn-purple btn-sm" @click.stop="$emit('printICF', accountableRow.item)"><i class="bx bx-printer"></i> Print ICF</button>
                            </div>
                        </div>
                        <span v-if="!accountableRow.item.showProperty">Show {{ accountableRow.item.totalItems }} properties</span>
                    </div>
                    <b-collapse
                        :visible="accountableRow.item.showProperty"
                        role="tabpanel"
                    >
                        <div v-if="accountableRow.item.showProperty">
                            <InventoryCardList 
                                type="notfound"
                                :filter="itemData.filter"
                                :accountableRow="accountableRow"
                            />
                            <!-- @changePropertyStatus="changePropertyStatus"
                            @printParProperty="$emit('printParProperty', $event)"
                            @printIcsProperty="$emit('printIcsProperty', $event)"
                            @printStickerProperty="$emit('printStickerProperty', $event)"
                            @printPropertyCard="$emit('printPropertyCard', $event)"
                            @updateItem="$emit('updateItem', $event)"
                            @deleteItem="$emit('deleteItem', $event)"
                            @getEmployee="$emit('getEmployee', $event)"
                            @getLocation="$emit('getLocation', $event)"
                            @checkToggle="checkToggle" -->
                        </div>
                    </b-collapse>
                </div>
            </template>
        </b-table>
        <div class="row">
            <div v-if="propertyRows > 0" class="col">
                Showing
                {{ (itemData.currentPage - 1) * itemData.perPage + 1 }} -
                {{ 
                    propertyRows > (itemData.currentPage - 1) * 
                    itemData.perPage + itemData.perPage ? 
                    (itemData.currentPage - 1) * itemData.perPage +
                    itemData.perPage
                    : propertyRows
                }}
                of {{ propertyRows }}
            </div>
            <div class="col">
                <div
                    @click="resetToggle(itemData)"
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                >
                    <b-pagination
                        v-model="itemData.currentPage"
                        :total-rows="propertyRows"
                        :per-page="itemData.perPage"
                    ></b-pagination>
                </ul>
                </div>
            </div>
        </div>
    </div>
</template>